import Button from "../universal/button"
import LinkButtonWrapper from "../universal/link-button-wrapper"
import React from "react"
import Textarea from "../../../shared/components/fields/textarea"
import { toast } from "react-toastify/unstyled"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"

/* global exponea */

const NewsletterSurveyForm = () => {
    const { t } = useTranslation("translations")

    const { handleSubmit, control, reset } = useForm({
        mode: "onTouched",
        defaultValues: {
            feedback: "",
        },
        context: undefined,
        criteriaMode: "firstError",
        shouldFocusError: true,
    })

    const submit = values => {
        if (exponea.isLoaded) {
            exponea.track("newsletter_survey", {
                feedback: values.feedback,
            })

            toast.success(t("newsletter_survey_form_success"), { autoClose: 5000, hideProgressBar: false })
            reset()
        } else {
            toast.error(t("newsletter_survey_form_error"))
        }
    }

    return (
        <form onSubmit={handleSubmit(submit)} name="newsletter_survey">
            <Textarea
                control={control}
                rules={{ required: { value: true, message: t("form_error_required") } }}
                name="feedback"
                label={t("newsletter_survey_form_feedback_label")}
                placeholder={t("newsletter_survey_form_feedback_placeholder")}
            />
            <LinkButtonWrapper>
                <Button submit title={t("newsletter_survey_form_submit")} />
            </LinkButtonWrapper>
        </form>
    )
}

export default NewsletterSurveyForm
